import axios from "axios";
import axiosInstance from "../../../../Utils/axios";
import { paginationQueryParams } from "../../../../Utils/paginationParam";
let cancelToken;

const grnAdditionalCostModURL = "api/v1/purchase-app/grn-additional-invoice-cost";

//obtaining the paginated data
export const getGrnAdditionalCost = ({ rowsPerPage, search, sortOrder, pageNo }) => {
  if (cancelToken) {
    cancelToken.cancel("Operation canceled due to new request.");
  }
  cancelToken = axios.CancelToken.source();

  return axiosInstance.get(
    `${grnAdditionalCostModURL}/list?${paginationQueryParams(rowsPerPage, search, sortOrder, pageNo)}`,
    {
      cancelToken: cancelToken.token,
    }
  );
};
//obtaining all fiscal sessions
export const getAllGrnAdditionalCost = () => axiosInstance.get(`${grnAdditionalCostModURL}/list?ordering=-id`);

//obtaining the previous page data from paginated data
export const getPrevious = (previous) => axiosInstance.get(previous);

//obtaining the next page data from paginated data
export const getNext = (next) => axiosInstance.get(next);

//obtaining the particular page data from paginated data
export const getPageGrnAdditionalCost = ({ number, rowsPerPage, search }) =>
  axiosInstance.get(
    `${grnAdditionalCostModURL}/list?offset=${(number - 1) * rowsPerPage}&limit=${rowsPerPage}&ordering=-id`
  );

export const getGrnAdditionalCostById = (id) => axiosInstance.get(`${grnAdditionalCostModURL}/retrieve/${id}`);

//creating function
export const createGrnAdditionalCost = (body) => axiosInstance.post(`${grnAdditionalCostModURL}/create`, body);
//updating function
export const updateGrnAdditionalCost = (id, body) =>
  axiosInstance.patch(`${grnAdditionalCostModURL}/update/${id}`, body);

//searching function
export const handleSearch = (rowsPerPage, search, sortOrder) =>
  axiosInstance.get(
    `${grnAdditionalCostModURL}/list?offset=0&limit=${rowsPerPage}&ordering=${sortOrder}&search=${search}`
  );

// checking the redundant data
export const checkRedundantDataGrnAdditionalCostName = (e, cancelToken) =>
  axiosInstance.get(`${grnAdditionalCostModURL}/list?name=${e.target.value.trim()}`, {
    cancelToken: cancelToken.token,
  });
